import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-payment-cancel',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './payment-cancel.html',
  styleUrls: ['./payment-cancel.scss']
})
export class PaymentCancel {

  constructor(public languageService: LanguageService) {}

  t(key: string): string {
    return this.languageService.translate(key);
  }
}
